export class NowaLokalizacjaModel {
    projektId: string;
    ulica: string;
    miasto: string;
    kodPocztowy: string;
    mPK: string;
    osobaOdpowiedzialna: string;
    numerTelefonu: string;
    rodzajLokalizacji: string;
    numerZespolu: string;
}